module.exports = __webpack_public_path__ + "img/var_01_backlight.af9e1603.svg";